import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class TimesheetResolver implements Resolve<moment.Moment> {
    public resolve(): moment.Moment {
        return moment();
    }
}
